module.exports = __webpack_public_path__ + "h5/img/bs_01.cbcbf2c8.jpg";